import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { Link } from 'react-router-dom';
import { Button, Alert } from 'react-bootstrap';
import moment from 'moment';

import LoaderButton from "./LoaderButton";
import '../styles/Home.css'

class Home extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
  }

  async login() {
    this.props.authService.login('/');
  }

  render() {
    const { isLoginComplete, userSet, applied, newUser, applicationSet, isFetchingCredentials, openTermSet, openTerm } = this.props;
    const { appOpenForStudents, appOpenDate, appCloseDate, name: termName } = openTerm;
    const now = moment();
    const openDate = moment(appOpenDate);
    const closeDate = moment(appCloseDate);
    const alive = (appOpenForStudents && now.isSameOrAfter(appOpenDate) && now.isSameOrBefore(appCloseDate));

    const applyStatus = () => {
      if(alive)
        return isLoginComplete && userSet ?
          newUser ?
            ( // alive, authenticated, set, new user
              <Alert bsStyle="warning">
                Please wait while your account is created.
              </Alert>
            )
            :
            applied ?
              ( // alive, authenticated, set, already applied
                <Fragment>
                  <p>You have already applied for this term.</p>
                  <Link to="/application">
                    <Button>View Submitted Application</Button>
                  </Link>
                </Fragment>
              )
              :
              ( // alive, authenticated, set, not applied
                <Alert bsStyle="success">
                  <Link to="/form">
                   <Button disabled={!applicationSet}>Apply</Button>
                  </Link>
                </Alert>
              )
          :
          ( // alive, not authenticated or not set
            <Alert bsStyle="warning">
              You must Log In to create an EOPS Application
              {!isLoginComplete &&
                <LoaderButton
                  isLoading={isFetchingCredentials}
                  onClick={this.login}
                  className="home-login"
                  glyph="log-in"
                  text="Log In"
                  loadingText="Logging In..."
                />
              }
            </Alert>
          );
      else
        return null;
    };

    const periodStatus = () => {
      const style = alive ? 'success' : 'warning';
      if(openTermSet)
        return (
          <Alert bsStyle={style}>
            <p>The {termName} Application Period is set to be open from <strong>{openDate.format('dddd, MMMM Do YYYY')}</strong> until <strong>{closeDate.format('dddd, MMMM Do YYYY')}</strong></p>
          </Alert>
        );
      else
        return null;
    };

    return (
      <div>
        <h1>Extended Opportunity Programs & Services (EOPS) Applications</h1>
        <p className="lead">Welcome to the SJDC EOPS Application System</p>
        <p>EOPS/CARE promotes the access, retention, persistence, and academic success of eligible full-time students
          challenged by economic, educational, and/or language barriers.</p>
        <p>EOPS offers qualified students:</p>
        <ul>
          <li>individualized counseling</li>
          <li>priority registration</li>
          <li>specialized workshops</li>
          <li>college tours</li>
          <li>tutoring</li>
          <li>transportation assistance</li>
          <li>help purchasing required textbooks</li>
          <li>other financial resources</li>
        </ul>
        <p>EOPS serves students for six consecutive semesters or until they have acquired seventy degree applicable units.</p>
        <p>For more information, please <a href='http://deltacollege.edu/department/eopscare'>visit the EOPS website</a>.</p>
        <hr/>
        <h2>Eligibility</h2>
        <p>To be eligible, you must meet the following requirements:</p>
        <ol>
        <li>Applied for and received the California Promise Grant A,B or C with 0 EFC.</li>
        <li>Enrolled in 12 units (no wait list classes; some DSPS students may qualify for waiver)</li>
        <li>Completed no more than 70 degree applicable units</li>
        <li>Meet one of the following educational criteria:</li>
          <ul>
            <li>Assessment into levels: Math 1 - 3 or English 1 - 2 or Reading 99 or non-degree applicable ESL</li>
            <li>Not a high school graduate or GED recipient</li>
            <li>Graduated from high school with less than a 2.5 GPA*</li>
            <li>Previously enrolled in remedial education outside of Delta College*</li>
            <li>Previously enrolled in remedial education at Delta College</li>
            <li>Special admit (with Director's approval as space allows) including: first generation
              college students, TANF/CalWORKs recipients, recently emancipated foster youth, and students whose parents speak English as a second language.</li>
          </ul>
        </ol>
        <p>If you meet the above criteria, you may apply for EOPS Services</p>
        {openTermSet &&
          <div>
            <hr/>
            <h2>Application Period</h2>
            {periodStatus()}
            {applyStatus()}
          </div>
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { auth, appInfo, application } = state;
  const {
    isLoginComplete,
    isFetchingCredentials,
    userSet
  } = auth;
  const {
    openTermSet,
    openTerm,
    newUser,
    applicationSet
  } = appInfo;
  return {
    isLoginComplete,
    userSet,
    applied: application.complete,
    newUser,
    applicationSet,
    isFetchingCredentials,
    openTermSet,
    openTerm
  }
}

export default connect(mapStateToProps)(withOktaAuth(Home))

